<template>
  <div class="header row align-center">
    <div class="menu-mobile show-s grid-2-s" @click="showMenu=!showMenu">
      <button :class="showMenu? 'close': ''"></button>
      <ul class="menu column" :class="showMenu ? 'opened': ''">
        <li>
          <router-link to="/dashboard/produtos">PRODUTOS</router-link>
        </li>
        <li>
          <router-link to="/dashboard/pilares">NOSSOS PILARES</router-link>
        </li>
       
        <li @click="SET_LOGOUT()">SAIR</li>
      </ul>
    </div>

    <div class="row grid-2-g grid-1-m grid-8-s align-center">
      <img src="../assets/img/logo-client.svg" class="logo show-g" alt="Logo NetSupport" />
      <img src="../assets/img/logo-client-icon.svg" class="logo-icon hide-g" alt="NetSupport" />
    </div>

    <div class="grid-7 hide-s">
      <ul class="menu row hide-s">
        <li :class="menu.products ? 'active': ''" @click="changeMenu('products')">
          <router-link to="/dashboard/produtos">PRODUTOS</router-link>
        </li>
        <li :class="menu.pillars ? 'active': ''" @click="changeMenu('pillars')">
          <router-link to="/dashboard/pilares">NOSSOS PILARES</router-link>
        </li>
       
      </ul>
    </div>

    <div class="grid-2-g grid-3-m grid-2-s row align-center justify-end">
      <Notify />
    </div>

    <div class="grid-2-g grid-3-m hide-s">
      <UserTab perfil="/supporter/perfil" account="/supporter/conta" />
    </div>
  </div>
</template>

<script>
import UserTab from "@/components/UserTab.vue";
import Notify from "@/components/Notify.vue";

import { mapActions } from "vuex";
export default {
  name: "Header",
  components: {
    UserTab,
    Notify
  },
  data() {
    return {
      showMenu: false,
      menu: {
        products: true,
        pillars: false
      }
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGOUT"]),
    changeMenu(active) {
      this.menu = { pillars: false, products: false };
      this.menu[active] = true;
    }
  },
  computed: {}
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;
.header {
  height: 70px;
  @media (max-width: $small) {
    height: 82px;
  }
  background: $gray-1;

  .logo {
    width: 163px;
    height: 33px;
    margin-left: 35px;
    display: none;
    &-icon {
      width: 45px;
      margin: auto;
    }
  }

  .menu {
    list-style: none;
    color: $white;
    font-size: 14px;
    font-weight: bold;

    & > li {
      margin-right: 25px;
      @media (min-width: $large) {
        margin-right: 50px;
      }

      padding: 25px 0px;
      a {
        padding: 25px 0px;
        color: $white;
      }
      &:hover {
        border-bottom: 5px solid $supporter-1;
        cursor: pointer;
        & ul {
          display: block;
        }
      }
      & ul {
        display: none;
        list-style: none;
        position: absolute;
        background: $gray-3;
        margin-top: 45px;
        margin-left: -25px;
        padding: 10px 0px;

        & li {
          padding: 15px 25px;
          text-transform: uppercase;
          &:hover {
            color: $green-1;
          }
        }
      }
    }

    .arrow-down {
      margin-left: 10px;
      font-size: 12px;
      color: $white;
    }
    & .active {
      border-bottom: 5px solid $white;
    }

    &-mobile {
      color: #fff;
      font-size: 30px;
      display: none;

      cursor: pointer;
      button {
        margin: 15% auto;
        display: block;
        width: 45px;
        height: 45px;
        position: relative;
        display: block;
        width: 18px;
        height: 2px;
        background: #fff;
        border-radius: 3px;
        cursor: pointer;
        transition: transform 0.2s ease;
        &::before {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          top: -10px;
          left: 0px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          left: 0px;
          top: 10px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }
        &.close {
          left: 5px;
          position: relative;
          display: block;
          width: 0;
          height: 0;
          background: transparent;
          transform: rotate(-180deg);
          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(-45deg);
            transition: transform 0.3s ease;
          }
          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(45deg);
            transition: transform 0.3s ease;
          }
        }
      }
      i {
        margin-left: 20px;
      }
      .menu {
        background: $gray-1;
        width: 100%;
        @media (min-width: 440px) {
          width: 100%;
        }

        position: absolute;
        top: -100%;
        z-index: 990;
        font-size: 1rem;
        padding: 31px 0px;
        font-weight: 300;
        li {
          padding: 1rem 31px;
        }
        /* display: none; */
        &.opened {
          top: 80px;
        }
      }
    }
  }
}
</style>
